import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import ExpressionModelEditDto from '../dto/ExpressionModelEditDto';

class ExpressionModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'expressionModelEditControl';
	}

	/**
	 * @param {string} driverName
	 * @return {Promise<ExpressionModelEditDto>}
	 */
	create(driverName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/create`, { driverName })
				.then(response => resolve(new ExpressionModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<ExpressionModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new ExpressionModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {ExpressionModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {ExpressionModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new ExpressionModelEditService();
